<template>
    <div class="modal fade" id="joinUs" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog become_custome__modal" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Join Us</h5>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submitApplication">
                        <div class="become_custome__form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="input-field">
                                        <input type="text" placeholder="Name"
                                            v-model="applicationForm.candidateName" />
                                            <div class="error-msg" v-if="applicationErrors.candidateName">{{ applicationErrors.candidateName }}</div>
                                  
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input-field">
                                        <input type="email" placeholder="Email"
                                            v-model="applicationForm.email" />
                                            <div class="error-msg" v-if="applicationErrors.email">{{ applicationErrors.email }}</div>
                                    
                           
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input-field">
                                        <select class="selectbox" v-model="applicationForm.designation" v-if="isFromOurTeamPage">
                                            <option value="">Select Job</option>
                                            <option v-for="category in jobCategories" :key="category.id"
                                                :value="category.title">
                                                {{ category.title }}
                                            </option>
                                        </select>
                                        <input 
                                            type="text" 
                                            v-model="applicationForm.designation" 
                                            :readonly="isFromJobDetailsPage"
                                            v-else
                                        />
                                        <div class="error-msg" v-if="applicationErrors.designation">{{ applicationErrors.designation }}</div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input-field">
                                        <input type="text" placeholder="Name of your Reference (if any)"
                                            v-model="applicationForm.nameOfReference" />
                                            
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="browse-input">
                                        <div class="browse-field">
                                            <div class="browse-button company-logo">Upload Image</div>
                                            <input type="file" @change="handleFileUpload($event)" accept="image/jpeg,image/jpg,image/png" :key="fileInputKey" />
                                            <!-- <div class="error-msg" v-if="!selectedImageFile">{{ errMsg }}</div> -->

                                        </div>
                                        <div class="browsed-img" v-if="imageUploaded"><img :src="imageUrl" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="browse-input">
                                        <div class="browse-field">
                                            <div class="browse-button company-logo">Upload Resume</div>
                                            <input type="file" @change="handleResumeUpload($event)" accept=".pdf" :key="fileInputKey" />
                                            <div class="error-msg" v-if="!selectedResumeFile && applicationErrors.candidateResume">{{ applicationErrors.candidateResume }}</div>
                                            <div class="custom-progress-bar" v-if="uploadProgress > 0">
                                                <div class="custom-progress-bar-left"> <span :style="`width:${uploadProgress}%`"></span></div>
                                                <div class="custom-progress-bar-right">{{uploadProgress}}%</div>
                                            </div>
                                        </div>
                                        <div class="browsed-img" v-if="resumeUploaded">{{ ResumeName }}</div>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="input-field"> <textarea placeholder="Details"
                                            v-model="applicationForm.description"></textarea>
                                            
                                        </div>
                                </div>
                            <div class="col-sm-12">
                                <div
                                id="captchaWidget"
                                class="g-recaptcha"
                                ></div>
                                <div class="error-msg" v-if="recaptchaError">
                                {{ recaptchaError }}
                                </div>
                            </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="primary-btn-outline" >{{ isSubmitting ? 'Submitting...' : 'Submit' }}</button>
                            <button type="button" class="dummy-btn" data-bs-dismiss="modal" ref="dummyButton"
                                style="display: none;"></button>
                            <button type="button" class="primary-btn-outline" @click="resetForm">Reset</button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '@/config/api.config';
import { loadRecaptchaScript } from '@/utils/captcha';
import { useRoute } from 'vue-router';
import { Modal } from "bootstrap";

declare global {
  interface Window {
    grecaptcha: {
      ready: (callback: () => void) => void;
      render: (
        container: string | HTMLElement,
        parameters: {
          sitekey: string;
          callback?: (token: string) => void;
          "expired-callback"?: () => void;
          theme?: "light" | "dark";
          size?: "normal" | "compact";
        }
      ) => number;
      reset: (widgetId?: number) => void;
      getResponse: (widgetId?: number) => string;
    };
    onRecaptchaLoad?: () => void;
    recaptchaCallbacks?: Array<() => void>;
  }
}

interface ApplicationForm {
    candidateName: string;
    email: string;
    designation: string;
    nameOfReference: string | null;
    candidateImage: string | null;
    candidateResume: File | null;
    description: string | null;
}

export default defineComponent({
    name: "jobForm",
    data() {
        return {
            applicationForm: {
                candidateName: '',
                email: '',
                designation: '',
                nameOfReference: null,   // Changed to null to indicate optional
                candidateImage: null,
                candidateResume: null,
                description: null        // Changed to null to indicate optional
            } as ApplicationForm,
            jobCategories: [] as any,
            imageSrc: '',
            selectedImageFile: null as File | null,
            imageUploaded: false,
            selectedResumeFile: null as File | null,
            errMsg: '',
            ResumeName: '',
            resumeUploaded: false,
            fileInputKey: 0,
            applicationErrors: {
            candidateName: '',
            email: '',
            designation: '',
            candidateResume:''
            }, // Replace errMsg with this
            isSubmitting: false,  // New flag to track submission state
            recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY!,
            recaptchaToken: "",
            recaptchaWidgetId: null as number | null,
            recaptchaError: "",
            uploadProgress: 0,
            isExtracting: false,
            missingDataQuestions: [] as Array<{missing_item: string, question: string}>,
            missingDataAnswers: {} as {[key: number]: string},
            extractedResumeSections: null as any,
            activeAccordion: -1,
            modalVisible: false,
            suppressLocalSave: false as boolean,
        }
    },
    computed: {
        imageUrl(): string {
            return this.imageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        isFromOurTeamPage(): boolean {
            const route = useRoute();
            return route.name === 'our-team';
        },
        isFromJobDetailsPage(): boolean {
            const route = useRoute();
            return route.name === 'readMoreAboutJob';
        },
        currentRoute() {
            return useRoute();
        },
        jobTitleFromRoute(): string {
            if (this.isFromJobDetailsPage) {
                const jobTitle = this.currentRoute.params.slug as string;
                return jobTitle ? decodeURIComponent(jobTitle) : '';
            }
            return '';
        },
    },
    mounted() {
        loadRecaptchaScript(this.onRecaptchaLoad.bind(this));
        this.getJobCategories();
        this.loadFromLocalStorage();
        this.setJobTitleFromRoute();
        const modalElement = document.getElementById('joinUs');
        if (modalElement) {
            modalElement.addEventListener('shown.bs.modal', this.onModalOpen);
            modalElement.addEventListener('hidden.bs.modal', this.onModalClose);
        }
    },
    watch: {
        'applicationForm.candidateName'() { this.saveToLocalStorage(); },
        'applicationForm.email'() { this.saveToLocalStorage(); },
        'applicationForm.designation'() { this.saveToLocalStorage(); },
        'applicationForm.nameOfReference'() { this.saveToLocalStorage(); },
        'applicationForm.description'() { this.saveToLocalStorage(); },
        'missingDataAnswers': {
            handler() { this.saveToLocalStorage(); },
            deep: true
        },
        'resumeUploaded'() { this.saveToLocalStorage(); },
        'imageUploaded'() { this.saveToLocalStorage(); },
        '$route'(to, from) {
            this.setJobTitleFromRoute();
        },
        modalVisible(newVal) {
            if (newVal && this.isFromJobDetailsPage) {
                this.$nextTick(() => {
                    this.setJobTitleFromRoute();
                });
            }
        },
        jobTitleFromRoute(newVal) {
            if (newVal && this.isFromJobDetailsPage) {
                this.applicationForm.designation = newVal;
            }
        }
    },

    beforeUnmount() {
        this.cleanupRecaptcha();
        const modalElement = document.getElementById('joinUs');
        if (modalElement) {
            modalElement.removeEventListener('shown.bs.modal', this.onModalOpen);
            modalElement.removeEventListener('hidden.bs.modal', this.onModalClose);
        }
    },
    methods: {

        isValidEmail(email: string): boolean {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
            },
        async submitApplication() {
            
            // If already submitting, prevent further submissions
            if (this.isSubmitting) {
                return;
            }

            this.applicationErrors = {
                candidateName: '',
                email: '',
                designation: '',
                candidateResume:''
            };
            let hasErrors = false;

            // Validate only required fields
            if (!this.applicationForm.candidateName) {
                this.applicationErrors.candidateName = 'Please enter a name';
                hasErrors = true;
            }
            if (!this.applicationForm.email) {
                this.applicationErrors.email = 'Please enter an email address';
                hasErrors = true;
            } else if (!this.isValidEmail(this.applicationForm.email)) {
                this.applicationErrors.email = 'Please enter a valid email address';
                hasErrors = true;
            }
            if (!this.applicationForm.designation) {
                this.applicationErrors.designation = 'Please select a job';
                hasErrors = true;
            }
            if (!this.selectedResumeFile) {
                this.applicationErrors.candidateResume = 'Please upload your resume.';
                hasErrors = true;
            } else if (!this.resumeUploaded || this.uploadProgress < 100) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Resume Upload',
                    text: 'Please wait for resume upload to complete.',
                    showConfirmButton: false,
                    timer: 1800
                });
                hasErrors = true;
            }
            if (!this.recaptchaToken) {
                this.recaptchaError = 'Please verify you are not a robot.';
                hasErrors = true;
            }

            // If there are errors in required fields, stop submission
            if (hasErrors) {
                if (
                    !this.recaptchaToken &&
                    window.grecaptcha &&
                    this.recaptchaWidgetId !== null
                ) {
                    window.grecaptcha.reset(this.recaptchaWidgetId);
                }
                return;
            }
            
            // Set submitting flag to true to disable the button
            this.isSubmitting = true;

            await axios.post(`${API_BASE_URL}/chat-message/`, {
                session_id: sessionStorage.getItem("chat_session_id"),
                message: "end_resume_questions_flow"
            });

            const formData = new FormData();
            formData.append('candidateName', this.applicationForm.candidateName);
            formData.append('email', this.applicationForm.email);
            formData.append('designation', this.applicationForm.designation);

            // Only append optional fields if they have values
            if (this.applicationForm.nameOfReference) {  // Check if nameOfReference is provided
                formData.append('nameOfReference', this.applicationForm.nameOfReference);
            }
            if (this.selectedImageFile) {  // Check if an image file is selected
                formData.append('candidateImage', this.selectedImageFile);
            }
            if (this.selectedResumeFile) {  // Check if a resume file is selected
                formData.append('candidateResume', this.selectedResumeFile);
            }
            if (this.applicationForm.description) {  // Check if description is provided
                formData.append('description', this.applicationForm.description);
            }
            formData.append('recaptchaToken', this.recaptchaToken);
            formData.append('isDirectApply', "true");
            if (this.extractedResumeSections) {
                formData.append('resume_sections', JSON.stringify(this.extractedResumeSections));
            }
            const savedData = localStorage.getItem('jobApplication_temp');
            if (savedData) {
                try {
                    const data = JSON.parse(savedData);
                    if (data.missingDataAnswers) this.missingDataAnswers = data.missingDataAnswers;
                    if (data.missingDataQuestions) this.missingDataQuestions = data.missingDataQuestions;
                } catch {}
            }
            if (this.missingDataQuestions && this.missingDataQuestions.length > 0) {
                const answersArray = this.missingDataQuestions.map((item, index) => ({
                    missing_item: item.missing_item,
                    question: item.question,
                    answer: (() => {
                        const v = (this.missingDataAnswers[index] ?? '').toString().trim();
                        return v ? v : '';
                    })()
                }));
                formData.append('missing_resume_data', JSON.stringify(answersArray));
            }
            
            try {
                const response = await axios.post(`${API_BASE_URL}/candidates/`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                this.resetForm();
                this.imageUploaded = false;
                this.resumeUploaded = false;
                this.suppressLocalSave = true;
                localStorage.removeItem('jobApplication_temp');
                (this.$refs.dummyButton as HTMLElement).click();
                Swal.fire({
                    icon: 'success',
                    title: 'Form Submitted Successfully!',
                    showConfirmButton: false,
                    timer: 1500
                });
            } catch (error : any) {
                console.log(error);
                Swal.fire({
                icon: 'error',
                title: 'Submission Failed',
                text: error?.response?.data.error || 'Something went wrong. Please try again.',
                showConfirmButton: true
                });
            }
             finally {
                // Reset submitting flag after the request completes (success or failure)
                this.isSubmitting = false;
                if (window.grecaptcha && this.recaptchaWidgetId !== null) {
                window.grecaptcha.reset(this.recaptchaWidgetId);
                }
            }

        },
        resetForm(){
            this.applicationForm={
                candidateName: '',
                email: '',
                designation: '',
                nameOfReference: null,   // Reset to null for optional field
                candidateImage: null,
                candidateResume: null,
                description: null        // Reset to null for optional field
            },
            this.selectedImageFile=null,
            this.selectedResumeFile=null,
            this.imageSrc = '';
            this.imageUploaded=false;
            this.resumeUploaded=false;
            this.ResumeName='';   
            this.fileInputKey++;
            this.uploadProgress = 0;
            this.missingDataQuestions = [];
            this.missingDataAnswers = {};
            this.extractedResumeSections = null;
            this.activeAccordion = -1;
            this.applicationErrors = {
                candidateName: '',
                email: '',
                designation: '',
                candidateResume:''
            };
            this.suppressLocalSave = true;
            localStorage.removeItem('jobApplication_temp');
            setTimeout(() => { this.suppressLocalSave = false; }, 0);
            if (
                window.grecaptcha &&
                document.getElementById("captchaWidget") &&
                this.recaptchaWidgetId !== null
            ) {
                console.log("Resetting reCAPTCHA widget for Join Us");
                try {
                window.grecaptcha.reset(this.recaptchaWidgetId);
                this.recaptchaWidgetId = null;
                this.recaptchaError = "";
                } catch (error) {
                console.error("Error resetting reCAPTCHA:", error);
                this.recaptchaWidgetId = null;
                }
            }

        },
        setJobTitleFromRoute() {
            if (this.isFromJobDetailsPage && this.jobTitleFromRoute) {
                this.applicationForm.designation = this.jobTitleFromRoute;
            }
        },
        onModalOpen() {
            this.modalVisible = true;
            this.setJobTitleFromRoute();
        },
        onModalClose() {
            this.modalVisible = false;
        },
        async getJobCategories() {
            try {
                const response = await axios.get(`${API_BASE_URL}/jobcategory/?status=1`);
                this.jobCategories = response.data;
            } catch (error) {
                console.error('Error fetching job categories:', error);
            }
        },
        handleFileUpload(event: any) {
            const target = event.target as HTMLInputElement;
            if (target && target.files && target.files.length > 0) {
                const file = target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    if (e.target && typeof e.target.result === 'string') {
                        this.imageSrc = e.target.result;
                        this.selectedImageFile = file;
                        this.imageUploaded = true

                    }
                };
            }
        },
        async handleResumeUpload(event: Event) {
            const target = event.target as HTMLInputElement;
            const file = target.files?.[0];
            if (!this.applicationForm.designation) {
                try {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Select Job',
                        text: 'Please select a job before uploading your resume.',
                        showConfirmButton: false,
                        timer: 1800
                    });
                } catch {}
                if (target) target.value = '';
                return;
            }
            if (file) {
                this.selectedResumeFile = file;
                this.ResumeName = this.selectedResumeFile.name;
                this.resumeUploaded = true;
                this.uploadProgress = 0;
                
                const progressInterval = setInterval(() => {
                    if (this.uploadProgress < 90) {
                        this.uploadProgress += 10;
                    }
                }, 100);
                
                await this.extractResumeData(file);
                
                clearInterval(progressInterval);
                this.uploadProgress = 100;
                
                this.saveToLocalStorage();
            }
        },
        async extractResumeData(file: File) {
            if (!this.applicationForm.designation) {
                console.log('No designation selected yet, skipping extraction');
                return;
            }
            
            this.isExtracting = true;
            
            try {
                const formData = new FormData();
                formData.append('resume', file);
                formData.append('designation', this.applicationForm.designation);
                
                const response = await axios.post(
                    `${API_BASE_URL}/candidates/extract-resume/`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
                
                if (response.data.success) {
                    this.extractedResumeSections = response.data.resume_sections;
                    if (response.data.missing_data && response.data.missing_data.length > 0) {
                        this.missingDataQuestions = response.data.missing_data;
                        this.missingDataAnswers = {};
                        this.missingDataQuestions.forEach((item, index) => {
                            this.missingDataAnswers[index] = '';
                        });
                        this.triggerResumeQuestionsFlow();
                    }
                    this.saveToLocalStorage();
                }
            } catch (error) {
                console.error('Error extracting resume:', error);
                Swal.fire({
                    icon: 'warning',
                    title: 'Resume Extraction',
                    text: 'Could not extract resume data. You can still submit your application.',
                    showConfirmButton: false,
                    timer: 2000
                });
            } finally {
                this.isExtracting = false;
            }
        },
        toggleAccordion(index: number) {
            this.activeAccordion = this.activeAccordion === index ? -1 : index;
        },
        async saveToLocalStorage() {
            if (this.suppressLocalSave) return;
            const existingRaw = localStorage.getItem('jobApplication_temp');
            let existing: any = {};
            try { existing = existingRaw ? JSON.parse(existingRaw) : {}; } catch { existing = {}; }
            const mergedMissingAnswers: Record<number, string> = { ...this.missingDataAnswers };
            const existingAnswers = (existing && existing.missingDataAnswers) ? existing.missingDataAnswers : {};
            if (existingAnswers && typeof existingAnswers === 'object') {
                Object.keys(existingAnswers).forEach((k: any) => {
                    const idx = Number(k);
                    const val = (existingAnswers[idx] ?? '').toString().trim();
                    if (val) mergedMissingAnswers[idx] = val;
                });
            }
            const dataToSave: any = {
                applicationForm: {
                    candidateName: this.applicationForm.candidateName,
                    email: this.applicationForm.email,
                    designation: this.applicationForm.designation,
                    nameOfReference: this.applicationForm.nameOfReference,
                    description: this.applicationForm.description
                },
                extractedResumeSections: this.extractedResumeSections,
                missingDataAnswers: mergedMissingAnswers,
                missingDataQuestions: this.missingDataQuestions,
                timestamp: new Date().toISOString()
            };
            
            if (this.selectedImageFile) {
                try {
                    const imageBase64 = await this.fileToBase64(this.selectedImageFile);
                    dataToSave.imageFile = {
                        name: this.selectedImageFile.name,
                        type: this.selectedImageFile.type,
                        data: imageBase64
                    };
                    dataToSave.imageSrc = this.imageSrc;
                } catch (error) {
                    console.error('Error converting image to base64:', error);
                }
            }
            
            if (this.selectedResumeFile) {
                try {
                    const resumeBase64 = await this.fileToBase64(this.selectedResumeFile);
                    dataToSave.resumeFile = {
                        name: this.selectedResumeFile.name,
                        type: this.selectedResumeFile.type,
                        data: resumeBase64
                    };
                    dataToSave.resumeName = this.ResumeName;
                } catch (error) {
                    console.error('Error converting resume to base64:', error);
                }
            }
            
            localStorage.setItem('jobApplication_temp', JSON.stringify(dataToSave));
        },
        loadFromLocalStorage() {
            const saved = localStorage.getItem('jobApplication_temp');
            if (saved) {
                try {
                    const data = JSON.parse(saved);
                    const savedTime = new Date(data.timestamp);
                    const now = new Date();
                    const hoursDiff = (now.getTime() - savedTime.getTime()) / (1000 * 60 * 60);
                    if (hoursDiff < 24) {
                        if (data.applicationForm) {
                            this.applicationForm.candidateName = data.applicationForm.candidateName || '';
                            this.applicationForm.email = data.applicationForm.email || '';
                            
                            if (this.isFromJobDetailsPage && this.jobTitleFromRoute) {
                                this.applicationForm.designation = this.jobTitleFromRoute;
                            } else {
                                this.applicationForm.designation = data.applicationForm.designation || '';
                            }
                            
                            this.applicationForm.nameOfReference = data.applicationForm.nameOfReference || null;
                            this.applicationForm.description = data.applicationForm.description || null;
                        }
                        this.extractedResumeSections = data.extractedResumeSections || null;
                        this.missingDataAnswers = data.missingDataAnswers || {};
                        if (data.missingDataQuestions) {
                            this.missingDataQuestions = data.missingDataQuestions;
                        }
                        if (data.imageFile) {
                            this.selectedImageFile = this.base64ToFile(
                                data.imageFile.data,
                                data.imageFile.name,
                                data.imageFile.type
                            );
                            this.imageSrc = data.imageSrc || '';
                            this.imageUploaded = true;
                        }
                        if (data.resumeFile) {
                            this.selectedResumeFile = this.base64ToFile(
                                data.resumeFile.data,
                                data.resumeFile.name,
                                data.resumeFile.type
                            );
                            this.ResumeName = data.resumeName || '';
                            this.resumeUploaded = true;
                            this.uploadProgress = 100;
                        }
                    } else {
                        localStorage.removeItem('jobApplication_temp');
                    }
                } catch (e) {
                    console.error('Error loading from localStorage:', e);
                }
            }
        },
        cleanupRecaptcha() {
            if (window.grecaptcha && this.recaptchaWidgetId !== null) {
                console.log("Cleaning up reCAPTCHA widget for Join Us");
                try {
                window.grecaptcha.reset(this.recaptchaWidgetId);
                this.recaptchaWidgetId = null;
                this.recaptchaToken = "";
                this.recaptchaError = "";
                } catch (error) {
                console.error("Error cleaning up reCAPTCHA:", error);
                this.recaptchaWidgetId = null;
                }
            }
        },

        onRecaptchaLoad() {
            console.log("reCAPTCHA script loaded for Join Us");
            this.renderRecaptcha();
        },

        renderRecaptcha() {
            const widgetElement = document.getElementById(
                "captchaWidget"
            );
            if (window.grecaptcha && widgetElement) {
                console.log("Rendering reCAPTCHA widget for Join Us");
                try {
                window.grecaptcha.ready(() => {
                    // Only render if widgetId is null and element is empty
                    if (
                    this.recaptchaWidgetId === null &&
                    !widgetElement.hasChildNodes()
                    ) {
                    this.recaptchaWidgetId = window.grecaptcha.render(
                        "captchaWidget",
                        {
                        sitekey: this.recaptchaSiteKey,
                        callback: this.onRecaptchaSuccess.bind(this),
                        "expired-callback": this.onRecaptchaExpired.bind(this),
                        }
                    );
                    this.recaptchaError = "";
                    } else {
                    console.log(
                        "reCAPTCHA widget already rendered or element not empty"
                    );
                    }
                });
                } catch (error) {
                console.error("Error rendering reCAPTCHA:", error);
                this.recaptchaError = "Failed to render reCAPTCHA. Please try again.";
                }
            } else {
                console.error("grecaptcha or captchaWidget not available");
                this.recaptchaError = "reCAPTCHA not available. Please try again.";
            }
        },

        onRecaptchaSuccess(token: string) {
            console.log("reCAPTCHA verified for Join Us, token:", token);
            this.recaptchaToken = token;
            this.recaptchaError = "";
        },

        onRecaptchaExpired() {
            console.log("reCAPTCHA expired for Join Us");
            this.recaptchaToken = "";
            this.recaptchaError = "reCAPTCHA has expired. Please try again.";
        },
        fileToBase64(file: File): Promise<string> {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result as string);
                reader.onerror = error => reject(error);
            });
        },
        base64ToFile(base64: string, filename: string, mimeType: string): File {
            const arr = base64.split(',');
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mimeType });
        },
        openChatbotPopup() {
            const chatbotElement = document.querySelector('.ai-chat-bot');
            if (chatbotElement) {
                chatbotElement.classList.add('show-chat-bot');
            }
        },
        closeChatbotPopup() {
            const chatbotElement = document.querySelector('.ai-chat-bot');
            if (chatbotElement) {
                chatbotElement.classList.remove('show-chat-bot');
            }
        },
        closeJobFormModal() {
            const modalElement = document.getElementById('joinUs');
            if (modalElement) {
                const modal = Modal.getInstance(modalElement);
                if (modal) {
                    modal.hide();
                }
            }
        },
        openJobFormModal() {
            const modalElement = document.getElementById('joinUs');
            if (modalElement) {
                const modal = new Modal(modalElement);
                modal.show();
            }
        },
        async triggerResumeQuestionsFlow() {
            // this.closeJobFormModal();
            this.openChatbotPopup();
            try {
                let sid = sessionStorage.getItem('chat_session_id');
                if (!sid) {
                    sid = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
                    sessionStorage.setItem('chat_session_id', sid);
                }
            } catch {}

            const initPayload = this.missingDataQuestions.map((item, index) => ({
                missing_item: item.missing_item,
                question: item.question,
                answer: (this.missingDataAnswers[index] || 'no')
            }));
            await axios.post(`${API_BASE_URL}/chat-message/`, {
                session_id: sessionStorage.getItem("chat_session_id"),
                message: JSON.stringify({ type: "resume_missing_data_init", data: initPayload })
            });

            await axios.post(`${API_BASE_URL}/chat-message/`, {
                session_id: sessionStorage.getItem("chat_session_id"),
                message: "start_resume_questions_flow"
            });

            const chatbotComponent = this.$refs?.chatbotPopup as any;
            if (chatbotComponent && typeof chatbotComponent.fetchHistory === 'function') {
                try {
                    await chatbotComponent.fetchHistory();
                } catch (e) {
                    setTimeout(() => {
                        if (typeof chatbotComponent.fetchHistory === 'function') {
                            chatbotComponent.fetchHistory();
                        }
                    }, 300);
                }
            }
            // Fallback broadcasts to ensure chatbot listens and refreshes history even without a direct ref
            window.dispatchEvent(new CustomEvent('chatbot:refresh'));
            setTimeout(() => window.dispatchEvent(new CustomEvent('chatbot:refresh')), 300);
            setTimeout(() => window.dispatchEvent(new CustomEvent('chatbot:refresh')), 800);
        }
    }
});
</script>
